class ScrollMv {
  constructor() {
    this.init();
  }

  init() {
    const scrollIcons = document.querySelectorAll('.js-c-mv-scroll, .js-mv-scroll');

    if (!scrollIcons.length) {
      return;
    }

    scrollIcons.forEach((icon) => {
      icon.addEventListener('click', (e) => {
        const href = icon.getAttribute('href');
        let target = href && href.startsWith('#')
          ? document.querySelector(href)
          : null;

        if (!target) {
          const mv = icon.closest('.c-mv');
          target = mv?.nextElementSibling;
        }

        if (!target) {
          return;
        }

        e.preventDefault();

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth';

        target.scrollIntoView({ behavior, block: 'start' });
      });
    });
  }
}
